var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab-doc"},[_c('div',{staticClass:"right-bottom"},[_c('fab')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }